import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ButtonLoading } from "go-form";
import { ReactComponent as ArrowSVG } from "../../../../../../../../images/svg/subscriptions/arrow.svg";
import {
	AvailableSubscriptionContentsApi,
	SubscriptionsApi,
} from "../../../../../../../../services/Api/Subscription/subscriptionTypes";
import SubscriptionSummaryPreviewSubscriptions from "./SubscriptionSummaryPreviewSubscriptions";
import SubscriptionSummaryPreviewTotals from "./SubscriptionSummaryPreviewTotals";
import { prepareAllSubscriptions } from "./utils";

interface Props {
	original: SubscriptionsApi;
	compare: SubscriptionsApi;
	handleSave: () => Promise<void>;
	loading: boolean;
	config: AvailableSubscriptionContentsApi;
}

enum SummaryTab {
	CURRENT = "CURRENT",
	PREVIOUS = "PREVIOUS",
}

const SubscriptionSummaryPreviewSubscriptionDetailsMobile = ({
	original,
	compare,
	loading,
	handleSave,
	config,
}: Props) => {
	const allSubscriptions = prepareAllSubscriptions(original, compare) as any[];
	const [currentTab, setCurrentTab] = useState<SummaryTab>(SummaryTab.CURRENT);
	const { t } = useTranslation();

	return (
		<Card className="subscriptions-summary-preview-details-card">
			<div className="row subscriptions-summary-preview-details-tabs">
				<div
					className={`col-6 current ${currentTab === SummaryTab.CURRENT ? "active" : ""}`}
					onClick={() => setCurrentTab(SummaryTab.CURRENT)}
				>
					Obecna subskrypcja
				</div>
				<div
					className={`col-6 previous ${currentTab === SummaryTab.PREVIOUS ? "active" : ""}`}
					onClick={() => setCurrentTab(SummaryTab.PREVIOUS)}
				>
					Poprzednia subskrypcja
				</div>
			</div>
			<Card.Body>
				<div className="row">
					<div className={"col subscription-summary-list-header original-app"}>Aplikacja/dodatki</div>
					<div className={"col text-end subscription-summary-list-header original-price"}>Cena</div>
				</div>
				<SubscriptionSummaryPreviewSubscriptions
					allSubscriptions={allSubscriptions}
					renderOnlyCurrentSubscription={currentTab === SummaryTab.CURRENT}
					renderOnlyPreviousSubscription={currentTab === SummaryTab.PREVIOUS}
					config={config}
				/>
				<div className="mt-1">
					<SubscriptionSummaryPreviewTotals
						original={original}
						compare={compare}
						renderOnlyCurrentSubscription={currentTab === SummaryTab.CURRENT}
						renderOnlyPreviousSubscription={currentTab === SummaryTab.PREVIOUS}
					/>
					<ButtonLoading
						onClick={handleSave}
						className="pay-subscriptions-btn mt-2"
						variant="primary"
						loading={loading}
					>
						{t("modules.subscription.action.pass_to_payment.title")}
						<ArrowSVG />
					</ButtonLoading>
				</div>
			</Card.Body>
		</Card>
	);
};

export default SubscriptionSummaryPreviewSubscriptionDetailsMobile;
